// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /pickem/standings-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typePickemStandingsGetBody,
  typePickemStandingsGetOutput200,
} from "../../sdk/pickem/postPickemStandingsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildPickemStandingsGetQueryKey(
  payload: typePickemStandingsGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`scope:${JSON.stringify(payload.scope)}`);
  if (typeof payload.contestId !== "undefined") {
    queryKeySegments.push(`contestId:${JSON.stringify(payload.contestId)}`);
  }
  if (typeof payload.seasonId !== "undefined") {
    queryKeySegments.push(`seasonId:${JSON.stringify(payload.seasonId)}`);
  }
  return [
    "post:pickem:pickemStandingsGet",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typePickemStandingsGetOutput200,
    unknown,
    typePickemStandingsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function usePickemStandingsGet(
  payload: typePickemStandingsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildPickemStandingsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postPickemStandingsGet(payload),
    ...resolvedOptions,
  });
}
